/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type AddBookmarkInput = {|
  postId?: ?string
|};
export type AddBookmarkMutationVariables = {|
  input: AddBookmarkInput
|};
export type AddBookmarkMutationResponse = {|
  +addBookmark: ?{|
    +bookmarkEdge: ?{|
      +cursor: string,
      +node: ?{|
        +id: string,
        +is_bookmarked: boolean,
      |},
    |},
    +viewer: ?{|
      +id: string
    |},
  |}
|};
export type AddBookmarkMutation = {|
  variables: AddBookmarkMutationVariables,
  response: AddBookmarkMutationResponse,
|};
*/


/*
mutation AddBookmarkMutation(
  $input: AddBookmarkInput!
) {
  addBookmark(input: $input) {
    bookmarkEdge {
      cursor
      node {
        id
        is_bookmarked
      }
    }
    viewer {
      id
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "AddBookmarkPayload",
    "kind": "LinkedField",
    "name": "addBookmark",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "SimpleBookmarkNodeEdge",
        "kind": "LinkedField",
        "name": "bookmarkEdge",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "cursor",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "SimpleBookmarkNode",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "is_bookmarked",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "SimpleBookmarkNode",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AddBookmarkMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AddBookmarkMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "889c8ce7588209841223944e31e0cfce",
    "id": null,
    "metadata": {},
    "name": "AddBookmarkMutation",
    "operationKind": "mutation",
    "text": "mutation AddBookmarkMutation(\n  $input: AddBookmarkInput!\n) {\n  addBookmark(input: $input) {\n    bookmarkEdge {\n      cursor\n      node {\n        id\n        is_bookmarked\n      }\n    }\n    viewer {\n      id\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'ab9b4d38c46a383e01e82d2e2edc6749';

module.exports = node;
